/**
 * API Client Configuration
 * Axios instance with base URL for API calls
 * Authentication is handled by Cloudflare Access
 */

import axios from 'axios';
import { API_BASE_URL } from './config';

// Create axios instance with base URL
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Important: Send cookies for Cloudflare Access
});

export default api;
